import { styled } from '@mui/material';

export const TableFooterCell = styled('td', {
  shouldForwardProp: (prop) => prop !== 'ariaColumnIndex',
})(() => ({}));
